import React, { useState } from 'react';
import { Info, Image } from 'lucide-react';
import natArchitectureImage from '../assets/images/nat-architecture.png';

function NatGatewayInfo() {
  const [isOpen, setIsOpen] = useState(false);
  const [showDiagram, setShowDiagram] = useState(false);

  const handleLearnMoreClick = () => {
    setIsOpen(true);
    setShowDiagram(false);
  };

  const handleDiagramClick = () => {
    setShowDiagram(true);
    setIsOpen(false);
  };

  return (
    <div className="ml-auto flex gap-2">
      <button
        onClick={handleLearnMoreClick}
        className="flex items-center justify-center gap-1 w-custom px-3 py-3 rounded-lg hover:opacity-90 bg-green-600 text-white"
      >
        <Info size={16} />
        Learn More
      </button>
      <button
        onClick={handleDiagramClick}
        className="flex items-center justify-center gap-1 w-custom px-3 py-3 rounded-lg hover:opacity-90 bg-purple-600 text-white"
      >
        <Image size={16} />
        Diagram
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-xl shadow-xl p-8 m-4 max-w-3xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-start mb-6">
              <div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-2">NAT Gateway</h3>
                <p className="text-gray-600">Secure outbound internet access for your private resources</p>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                ×
              </button>
            </div>

            <div className="grid grid-cols-2 gap-6 mb-6">
              <div className="bg-green-50 border border-green-100 rounded-lg p-4">
                <h4 className="text-md font-medium text-green-900 mb-2">Benefits</h4>
                <ul className="space-y-2 text-sm text-green-800">
                  <li>• Enables secure outbound internet access</li>
                  <li>• Prevents direct exposure of private resources</li>
                  <li>• Simplified security management</li>
                  <li>• Automatic scaling based on demand</li>
                </ul>
              </div>

              <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
                <h4 className="text-md font-medium text-blue-900 mb-2">Key Features</h4>
                <ul className="space-y-2 text-sm text-blue-800">
                  <li>• High availability within AZ</li>
                  <li>• Automatic IP address management</li>
                  <li>• Security at the subnet level</li>
                  <li>• Built-in redundancy</li>
                </ul>
              </div>
            </div>

            <div className="bg-gray-50 border border-gray-100 rounded-lg p-4">
              <h4 className="text-md font-medium text-gray-900 mb-2">When You Need Multiple NAT Gateways</h4>
              <ul className="space-y-2 text-sm text-gray-800">
                <li>• For DR environments to ensure high availability</li>
                <li>• When resources are spread across availability zones</li>
                <li>• To maintain separate traffic flows for different environments</li>
                <li>• To improve fault tolerance and reduce single points of failure</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {showDiagram && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-xl shadow-xl p-8 m-4 max-w-5xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-2xl font-semibold text-gray-900">NAT Gateway Architecture</h3>
              <button
                onClick={() => setShowDiagram(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                ×
              </button>
            </div>
            <img 
              src={natArchitectureImage} 
              alt="NAT Gateway Architecture Diagram" 
              className="w-full h-auto"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default NatGatewayInfo;
